import { render, staticRenderFns } from "./BuyDomain.vue?vue&type=template&id=0121f8d9"
import script from "./BuyDomain.vue?vue&type=script&lang=js"
export * from "./BuyDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports